import { ErrorMessageStrategy } from '@shared/utils/interfaces';

export const domainConfigurationEmptyStrategy: ErrorMessageStrategy = () => {
  return {
    translationKey: 'errors.DOMAIN_CONFIGURATION_EMPTY',
  };
};
